@if (goalData(); as goalData) {
<section class="goal-header" [class.astrazeneca]="isAstraZeneca()">
  <div class="goal-header-content">
    <div class="goal-header-top-bar">
      <div class="goal-header-brand">
        <img [src]="'assets/images/logo/kinomap_primary_' + (isAstraZeneca() ? 'black' : 'white') + '.webp'"
          alt="Kinomap logo" />
        <p class="goal-header-username">
          <span class="goal-header-username-separator">/</span> {{ goalData.user.username }}
        </p>
      </div>
      <div class="goal-header-avatar">
        <img [src]="goalData.user.avatar_url" [alt]="goalData.user.full_name" />
      </div>
    </div>

    <div class="goal-header-body">
      <h1 class="goal-header-title">Parcourons ensemble {{ goalData.goal }}km</h1>
      <p class="user-description" [style.color]="isAstraZeneca() ?  '#7e8184' : '#c1c1c1'"
        [innerHTML]="goalData.user.description ?? ''"></p>

      <div class="goal-header-progress-bar">
        <app-goal-progress-bar [isAstraZeneca]="isAstraZeneca()" [progress]="goalData.global_percentage"
          [totalDistance]="goalData.goal" [currentDistance]="goalData.total_distance_km"
          [nbParticipants]="goalData.count_last_activities" />
      </div>
    </div>
  </div>
</section>
}